import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { useAppSelector } from "../../redux/store/hooks"
import {
    selectMedicationRisks,
    selectMedicationTimestamp
} from "../../redux/ProfessionalDashboard"
import { useEffect, useState } from "react"
import { MedicationRiskCounterMeasure } from "pokal_api"
import notNull from "../../util/notNull"
import SingleCounterMeasureView from "./component/SingleCounterMeasureView"
import medIsCoMed from "../../util/medIsCoMed"

function MedicationCounterMeasureView() {
    const timestamp = useAppSelector(selectMedicationTimestamp)
    const risks = useAppSelector(selectMedicationRisks)

    const [counterMeasures, setCounterMeasures] = useState<
        MedicationRiskCounterMeasure[]
    >([])

    useEffect(() => {
        if (notNull(risks)) {
            const updatedRisks = risks[timestamp].counterMeasures
            const sortedUpdatedRisks = [...updatedRisks].sort((a, b) =>
                a.id < b.id ? -1 : a.id > b.id ? 1 : 0
            )
            setCounterMeasures(sortedUpdatedRisks)
        }
    }, [timestamp, risks])

    return (
        <Card>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>Geplante Maßnahmen</SmallHeadingComponent>
                {counterMeasures.length > 0 && (
                    <div>Hier tragen Sie aufgrund der erhaltenen Informationen über Übermedikation und Therapierisiken ein, ob für diesen Arzneistoff eine Maßnahme planen möchten und wie diese Maßnahme aussehen soll (z.B. Eintrag in Patientenakte, Absetzversuch, ...):</div>
                )}
                {counterMeasures.length === 0 && (
                    <div className={"italic"}>
                        Es wird kein Antidepressivum eingenommen.
                    </div>
                )}
                <div className={"flex flex-col space-y-8"}>
                    {counterMeasures.filter((c) => !medIsCoMed(c.atc)).map((c) => (
                        <SingleCounterMeasureView
                            key={c.id}
                            counterMeasure={c}
                        />
                    ))}
                    {counterMeasures.filter((c) => medIsCoMed(c.atc)).map((c) => (
                        <SingleCounterMeasureView
                            key={c.id}
                            counterMeasure={c}
                        />
                    ))}
                </div>
            </div>
        </Card>
    )
}

export default MedicationCounterMeasureView
